import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { Transition } from "./ModalConstants";

type ActivateDeactivateUserProps = {
  loading: boolean;
  onClose: () => void;
  willAction: () => void;
  userActionLabel: string;
};

function ActivateDeactivateUser({ loading, onClose, willAction, userActionLabel }: ActivateDeactivateUserProps) {
  return (
    <div>
      <Dialog
        open
        onClose={onClose}
        TransitionComponent={Transition as any}
        className="mainDialog"
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle className="flex dialogTitle" style={{ borderBottom: "1px solid " }} id="responsive-dialog-title">
          {userActionLabel}
          <CloseIcon className="pointer" sx={{ ml: "auto" }} onClick={onClose} />
        </DialogTitle>

        <DialogContent className="dialogContent" style={{ padding: "10px !important" }}>
          Do You Want to {userActionLabel} This User ?
        </DialogContent>

        <DialogActions className="dialogBtn">
          <Button variant="outlined" autoFocus onClick={onClose}>
            Cancel
          </Button>
          <Button color="error" variant="contained" autoFocus onClick={willAction}>
            {loading ? <CircularProgress style={{ width: "22px", height: "22px" }} /> : "YES"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ActivateDeactivateUser;
